import { useHookstate } from "@hookstate/core";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";

export function useNavigationHistory() {
  const location = useLocation();
  const locationHistory = useHookstate(rootComponentsStore.locationHistory);

  useEffect(() => {
    const fullPath = location.pathname + location.search + location.hash;
    if (locationHistory[locationHistory.length - 1].get() === fullPath) return;
    locationHistory[locationHistory.length].set(fullPath);
  }, [location]);
}
